import React from 'react';
import Collapsible from 'react-collapsible';

export const AppCollapsible = (props) =>  {
   return (
       <Collapsible
           transitionTime={100}
           trigger="Edit"
           triggerWhenOpen="Ok"
           triggerTagName="button"
       >
           { props.children }
       </Collapsible>
   )
};
